export const CONTACT = 'CONTACT';
export const MARKETING_CONTACT_DEPRECATED = 'MARKETING_CONTACT';
export const USER = 'USER';
export const UNIT = 'UNIT';